import FormeJuridiqueSelect from '@/generated/controls/formeJuridique/FormeJuridiqueSelect.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: FormeJuridiqueSelect
})
